import { Container, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom";
import "../../assets/css/ClientResponsive.css";
import ClientHeader from "./ClientHeader";
import ClientSidebar from "./ClientSidebar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setLicences,
  setPictureBoardData,
  setSelectedClientdata,
  setNoLicenseAccess
} from "../../redux/actions/actions";
// import { NotificationProvider } from "../../connect/coman/NotificationProvider";
import { Getrequestcall } from "../../request/Getrequest";
import {
  GET_CLIENT_APPROVED_PICTUREBOARD,
} from "../../constant/Apipath";
import ClientLayoutSkeleton from "../clientLayout/ClientLayoutSkeleton";
import NoLicenseScreen from "../clientLayout/NoLicenseScreen";
import {
  fetchClientEmployeeAppsLicensesDetails,
  normalizeClientEmployeeAppsLicensesResponse
} from "../utils/clientEmployeeAppsLicenses";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar
}));

function ClientLayout() {
  const navigate = useNavigate();
  const location = useLocation(); // Track the current route
  const [mobileSidebar, setMobileSidebar] = useState(false);
  const { id } = useParams();
  const dispatch = useDispatch();
  const { loginData, selectedClientData, noLicenseAccess } = useSelector((state) => state?.main);
  const [allLoaded, setAllLoaded] = useState(false);
  // const [isRefreshed, setIsRefreshed] = useState(sessionStorage.getItem("hasRefreshed")); // To track page refresh
  const [isRefreshed, setIsRefreshed] = useState(() => {
    const storedValue = sessionStorage.getItem("hasRefreshed");
    return storedValue === "true"; // converts "true" string to actual boolean
  });

  useEffect(() => {
    // Detect page refresh using session storage
    const hasRefreshed = sessionStorage.getItem("hasRefreshed");
    if (!hasRefreshed) {
      sessionStorage.setItem("hasRefreshed", "true");
      setIsRefreshed(true);
    }
  }, []);

  useEffect(() => {
    if (!id) return; // Don't run if there is no ID (e.g. during logout or on non-client pages)

    const fetchData = async () => {
      setAllLoaded(false);
      dispatch(setNoLicenseAccess(false));
      dispatch(setLicences({ status: 0, data: { data: [] } }));

      let clientId = "";
      if (id) {
        const selectedClientObj = loginData?.userInformation?.ClientsList?.find(
          (client) => client?.ClientId == id
        );
        if (!selectedClientObj) {
          navigate("/home");
          alert("Client Not Found");
          return;
        }
        clientId = selectedClientObj;
        dispatch(setSelectedClientdata(selectedClientObj));
      }

      const getData = async (selectedClientData) => {
        try {
          let appLicenceResponse = await fetchClientEmployeeAppsLicensesDetails(
            selectedClientData?.ClientId,
            selectedClientData?.ClientEmployeeId,
            loginData?.accessToken
          );
          const licenceResponse = appLicenceResponse?.response ?? appLicenceResponse;
          dispatch(setLicences(normalizeClientEmployeeAppsLicensesResponse(licenceResponse)));

          if (licenceResponse?.status === 200) {
            return true;
          } else {
            console.log("getAppLicence-> Error In App Licence Data");
            return true;
          }
        } catch (error) {
          console.log("getAppLicence-> Error Getting App Licence Data: ", error);
          return false;
        }
      };

      const getPictureboardData = async (selectedClientData) => {
        try {
          const pictureBoardResponse = await Getrequestcall(
            GET_CLIENT_APPROVED_PICTUREBOARD + selectedClientData?.ClientId,
            loginData?.accessToken
          );
          if (pictureBoardResponse.status === 200) {
            dispatch(setPictureBoardData(pictureBoardResponse?.data?.data));
            return true;
          } else {
            console.log("getPictureBoardData-> Error Getting Pictureboard Data");
            return false;
          }
        } catch (error) {
          console.log("getPictureBoardData-> Error Getting Pictureboard Data: ", error);
          return false;
        }
      };

      const fetchAll = async () => {
        const [licenceOk, pictureboardOk] = await Promise.all([
          getData(clientId),
          getPictureboardData(clientId)
        ]);
        if (licenceOk && pictureboardOk) {
          setAllLoaded(true);
        }
      };

      fetchAll();
    };

    // Call API when:
    // 1. The component mounts (first visit or refresh).
    // 2. The clientId changes.
    // 3. The user navigates to the /home route.
    if (isRefreshed === true || location.pathname.includes("/home")) {
      fetchData();
      setIsRefreshed(true); // Reset refresh flag after fetching data
    }
  }, [id]);

  if (noLicenseAccess) {
    return (
      <Box sx={{ display: "flex" }} className="main-base">
        <ClientHeader setMobileSidebar={setMobileSidebar} />
        <ClientSidebar setMobileSidebar={setMobileSidebar} mobileSidebar={mobileSidebar} />
        <Box
          component="main"
          className="main-content"
          sx={{
            flexGrow: 1,
            p: 1
          }}>
          <Container className="main-container">
            <NoLicenseScreen
              clientColor={selectedClientData?.AccentColor || selectedClientData?.ClientColor}
              organizationName={selectedClientData?.OrganizationName}
            />
          </Container>
        </Box>
      </Box>
    );
  }

  return !allLoaded ? (
    <ClientLayoutSkeleton />
  ) : (
    <>
      <Box sx={{ display: "flex" }} className="main-base">
        {/* <NotificationProvider> */}
        <ClientHeader setMobileSidebar={setMobileSidebar} />
        {/* </NotificationProvider> */}
        <ClientSidebar setMobileSidebar={setMobileSidebar} mobileSidebar={mobileSidebar} />
        <Box
          component="main"
          className="main-content"
          sx={{
            flexGrow: 1,
            p: 1
          }}>
          {/* <DrawerHeader /> */}
          <Container className="main-container">
            <Outlet />
          </Container>
        </Box>
      </Box>
    </>
  );
}

export default ClientLayout;
